import { Card, Descriptions } from "antd";
import { AddressInterface } from "api/enumerator/Profile/dto";

interface AddressInfoProps {
  title: string;
  address: AddressInterface; // Replace with your address type
}

export const AddressInfo = ({ title, address }: AddressInfoProps) => (
  <Card className="mt-6">
    <Descriptions
      title={title}
      layout="vertical"
      column={{ xxl: 4, xl: 4, lg: 4, md: 1, sm: 1, xs: 1 }}
    >
      <Descriptions.Item label="Province">{address?.province || "-"}</Descriptions.Item>
      <Descriptions.Item label="District">{address?.district || "-"}</Descriptions.Item>
      <Descriptions.Item label="Municipality">{address?.municipality || "-"}</Descriptions.Item>
      <Descriptions.Item label="Ward">{address?.ward || "-"}</Descriptions.Item>
    </Descriptions>
  </Card>
);